export default "__VITE_ASSET__BJYjoxRe__"